import React from 'react';

import commonScreen, { Props } from '../common/Common.screen';

const Cancellation: React.FunctionComponent<Props> = ({ title, subtitle, desc }: Props) => {
  return commonScreen({ title, subtitle, desc });
};

export default Cancellation;
